import { AnyAction } from '@reduxjs/toolkit';
import { ShellStore } from '@vfmfe/foundations';
import { createContext } from 'react';
import {
    createDispatchHook,
    createSelectorHook,
    createStoreHook,
    ReactReduxContextValue,
    TypedUseSelectorHook
} from 'react-redux';

const DigitalContext = createContext<ReactReduxContextValue<unknown, AnyAction> | null>(null);
window.DigitalContext = DigitalContext;

export const useSelector: TypedUseSelectorHook<ShellStore> = createSelectorHook(window.DigitalContext);
export const useDispatch = createDispatchHook(window.DigitalContext);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useStore = createStoreHook<ShellStore>(window.DigitalContext as any);
